// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideBarChatHistoryInput_input__Ifqio {
    width: 100%;
    background-color: transparent;
    border: none;
    color: #fff;
    font-size: 14px;
    font-family: 'PingFangSCMedium', sans-serif;
    background-color: #717171;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/SideBarChatHistoryInput/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,6BAA6B;IAC7B,YAAY;IACZ,WAAW;IACX,eAAe;IACf,2CAA2C;IAC3C,yBAAyB;AAC7B","sourcesContent":[".input {\n    width: 100%;\n    background-color: transparent;\n    border: none;\n    color: #fff;\n    font-size: 14px;\n    font-family: 'PingFangSCMedium', sans-serif;\n    background-color: #717171;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `SideBarChatHistoryInput_input__Ifqio`
};
export default ___CSS_LOADER_EXPORT___;
